export const BANNER_TYPE = {
  BANNER: "BANNER",
  POPUP: "POPUP",
  ANNOUNCEMENT_BAR: "ANNOUNCEMENT_BAR",
};

export const BANNER_TYPE_LABELS = {
  [BANNER_TYPE.BANNER]: "BANNER",
  [BANNER_TYPE.POPUP]: "POPUP",
  [BANNER_TYPE.ANNOUNCEMENT_BAR]: "Announcement Bar",
};

export const BANNER_TYPE_COLORS = {
  [BANNER_TYPE.BANNER]: {
    color: "#2246dc",
    background: "#f0f4fe",
    border: "#d0dcfa",
  },
  [BANNER_TYPE.POPUP]: {
    color: "#27a745",
    background: "#f2f9f3",
    border: "#c3e6cb",
  },
  [BANNER_TYPE.ANNOUNCEMENT_BAR]: {
    color: "#ff7a00",
    background: "#fff8f0",
    border: "#ffe2cc",
  },
};

export const BANNER_SOURCE = {
  MANUAL: "MANUAL",
  PROMOTION: "PROMOTION",
};

export const BANNER_SOURCE_LABELS = {
  [BANNER_SOURCE.MANUAL]: "Thủ công",
  [BANNER_SOURCE.PROMOTION]: "Chương trình khuyến mãi",
};

export const TIME_STATUS = {
  ALL: "ALL",
  UPCOMING: "UPCOMING",
  ONGOING: "ONGOING",
  ENDED: "ENDED",
};

export const TIME_STATUS_LABELS = {
  [TIME_STATUS.ALL]: "Tất cả",
  [TIME_STATUS.UPCOMING]: "Sắp diễn ra",
  [TIME_STATUS.ONGOING]: "Đang diễn ra",
  [TIME_STATUS.ENDED]: "Đã kết thúc",
};

export const TIME_STATUS_DOT_COLORS = {
  [TIME_STATUS.UPCOMING]: "#ff9900", // Orange
  [TIME_STATUS.ONGOING]: "#27ae60", // Green
  [TIME_STATUS.ENDED]: "#e74c3c", // Red
};

export const SELLER_SEGMENT_TYPE = {
  ALL: "ALL",
  NO_ORDER: "NO_ORDER",
  NOT_PURCHASED_PRODUCT: "NOT_PURCHASED_PRODUCT",
};

export const SELLER_SEGMENT_LABELS = {
  [SELLER_SEGMENT_TYPE.ALL]: "Tất cả đại lý",
  [SELLER_SEGMENT_TYPE.NO_ORDER]: "Đại lý chưa từng phát sinh đơn hàng",
  [SELLER_SEGMENT_TYPE.NOT_PURCHASED_PRODUCT]: "Đại lý chưa từng mua các sản phẩm này",
};

export const NAVIGATION_TYPE = {
  PROMOTION_CAMPAIGN: "PROMOTION_CAMPAIGN",
  PRODUCT_DETAIL: "PRODUCT_DETAIL",
  CATEGORY: "CATEGORY",
  BRAND: "BRAND",
  LANDING_PAGE: "LANDING_PAGE",
  APP_FEATURE: "APP_FEATURE",
  NONE: "NONE",
};

export const NAVIGATION_TYPE_LABELS = {
  [NAVIGATION_TYPE.PROMOTION_CAMPAIGN]: "Chương trình khuyến mãi",
  [NAVIGATION_TYPE.PRODUCT_DETAIL]: "Chi tiết sản phẩm",
  [NAVIGATION_TYPE.CATEGORY]: "Ngành hàng",
  [NAVIGATION_TYPE.BRAND]: "Thương hiệu",
  [NAVIGATION_TYPE.LANDING_PAGE]: "Link Blog / Landingpage",
  [NAVIGATION_TYPE.APP_FEATURE]: "Tính năng mới trên app",
  [NAVIGATION_TYPE.NONE]: "Không điều hướng",
};

export const BANNER_SCREENS = {
  HOME: "HOME",
  WELCOME: "WELCOME",
  SEARCH: "SEARCH",
  PRODUCT_LIST: "PRODUCT_LIST",
  CATEGORY_LIST: "CATEGORY_LIST",
  CHAT: "CHAT",
  NOTIFICATION: "NOTIFICATION",
  PROFILE: "PROFILE",
  WARRANTY_LOOKUP: "WARRANTY_LOOKUP",
  VOUCHER: "VOUCHER",
  ORDER_COMPLETE: "ORDER_COMPLETE",
};

export const BANNER_SCREEN_LABELS = {
  [BANNER_SCREENS.HOME]: "Màn Trang chủ",
  [BANNER_SCREENS.WELCOME]: "Màn Welcome",
  [BANNER_SCREENS.SEARCH]: "Màn Tìm kiếm",
  [BANNER_SCREENS.PRODUCT_LIST]: "Màn Danh sách sản phẩm",
  [BANNER_SCREENS.CATEGORY_LIST]: "Màn Danh mục ngành hàng",
  [BANNER_SCREENS.CHAT]: "Màn Tin nhắn",
  [BANNER_SCREENS.NOTIFICATION]: "Màn Thông báo",
  [BANNER_SCREENS.PROFILE]: "Màn Cá nhân",
  [BANNER_SCREENS.WARRANTY_LOOKUP]: "Màn Tra cứu bảo hành",
  [BANNER_SCREENS.VOUCHER]: "Màn Mã giảm giá",
  [BANNER_SCREENS.ORDER_COMPLETE]: "Màn Hoàn tất đơn hàng",
};

/** Màn hình yêu cầu ảnh vuông 1500x1500 */
export const SQUARE_IMAGE_SCREENS = [BANNER_SCREENS.WELCOME, BANNER_SCREENS.CHAT, BANNER_SCREENS.WARRANTY_LOOKUP];

export const POPUP_TRIGGER_TYPE = {
  APP_OPEN_OR_SCREEN_ENTER: "APP_OPEN_OR_SCREEN_ENTER",
  SCREEN_EXIT: "SCREEN_EXIT",
};

export const POPUP_TRIGGER_TYPE_LABELS = {
  [POPUP_TRIGGER_TYPE.APP_OPEN_OR_SCREEN_ENTER]: "Mở app / Truy cập màn tương ứng thành công",
  [POPUP_TRIGGER_TYPE.SCREEN_EXIT]: "Đại lý thoát màn hình",
};

export const POPUP_TRIGGER_DELAY_UNIT = {
  SECOND: "SECOND",
  MINUTE: "MINUTE",
  HOUR: "HOUR",
};

export const POPUP_TRIGGER_DELAY_UNIT_LABELS = {
  [POPUP_TRIGGER_DELAY_UNIT.SECOND]: "Giây",
  [POPUP_TRIGGER_DELAY_UNIT.MINUTE]: "Phút",
  [POPUP_TRIGGER_DELAY_UNIT.HOUR]: "Giờ",
};

export const POPUP_FREQUENCY_PERIOD = {
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
};

export const POPUP_FREQUENCY_PERIOD_LABELS = {
  [POPUP_FREQUENCY_PERIOD.DAY]: "Ngày",
  [POPUP_FREQUENCY_PERIOD.WEEK]: "Tuần",
  [POPUP_FREQUENCY_PERIOD.MONTH]: "Tháng",
};

export const ANNOUNCEMENT_BAR_POSITION = {
  TOP: "TOP",
  BOTTOM: "BOTTOM",
};

export const ANNOUNCEMENT_BAR_POSITION_LABELS = {
  [ANNOUNCEMENT_BAR_POSITION.TOP]: "Đầu màn (dưới header)",
  [ANNOUNCEMENT_BAR_POSITION.BOTTOM]: "Cuối màn (footer)",
};

export const ANNOUNCEMENT_BAR_DISPLAY_TYPE = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
};

export const ANNOUNCEMENT_BAR_DISPLAY_TYPE_LABELS = {
  [ANNOUNCEMENT_BAR_DISPLAY_TYPE.TEXT]: "Text + Icon + CTA",
  [ANNOUNCEMENT_BAR_DISPLAY_TYPE.IMAGE]: "Ảnh",
};

export const ANNOUNCEMENT_BAR_ICON_MODE = {
  NONE: "NONE",
  PRESET: "PRESET",
  UPLOAD: "UPLOAD",
};

export const ANNOUNCEMENT_BAR_BACKGROUND_MODE = {
  PRESET: "PRESET",
  SOLID: "SOLID",
  GRADIENT: "GRADIENT",
  UPLOAD: "UPLOAD",
};

export const COLOR_PRESETS = [
  {
    code: "green_mint",
    name: "Xanh tươi mát",
    background: "#00a86b",
    textColor: "#ffffff",
    buttonColor: "#ffffff",
    buttonTextColor: "#00a86b",
  },
  {
    code: "red_highlight",
    name: "Đỏ nổi bật",
    background: "#d62828",
    textColor: "#ffffff",
    buttonColor: "#ffffff",
    buttonTextColor: "#d62828",
  },
  {
    code: "orange_warm",
    name: "Cam rực rỡ",
    background: "#ff7a00",
    textColor: "#ffffff",
    buttonColor: "#ffffff",
    buttonTextColor: "#ff7a00",
  },
  {
    code: "purple_creative",
    name: "Tím sáng tạo",
    background: "#8338ec",
    textColor: "#ffffff",
    buttonColor: "#ffffff",
    buttonTextColor: "#8338ec",
  },
  {
    code: "yellow_gold",
    name: "Vàng kim khí",
    background: "#ffbe0b",
    textColor: "#1a1a1a",
    buttonColor: "#1a1a1a",
    buttonTextColor: "#ffbe0b",
  },
  {
    code: "blue_brand",
    name: "Xanh thương hiệu",
    background: "#2246dc",
    textColor: "#ffffff",
    buttonColor: "#ffffff",
    buttonTextColor: "#2246dc",
  },
  {
    code: "dark_elegant",
    name: "Đen sang trọng",
    background: "#212529",
    textColor: "#ffffff",
    buttonColor: "#ffffff",
    buttonTextColor: "#212529",
  },
  {
    code: "gray_neutral",
    name: "Xám thông tin",
    background: "#6c757d",
    textColor: "#ffffff",
    buttonColor: "#ffffff",
    buttonTextColor: "#6c757d",
  },
];

export const ICON_PRESETS = [
  { code: "gift", name: "Quà tặng", icon: "gift" },
  { code: "voucher", name: "Voucher", icon: "ticket" },
  { code: "discount", name: "Giảm giá %", icon: "percent" },
  { code: "truck", name: "Freeship", icon: "truck" },
  { code: "flash_sale", name: "Flash sale", icon: "bolt" },
  { code: "hot", name: "Hot", icon: "fire" },
  { code: "clock", name: "Đồng hồ", icon: "clock" },
  { code: "speaker", name: "Loa", icon: "bullhorn" },
  { code: "sparkle", name: "Ngôi sao", icon: "star" },
  { code: "tag", name: "Thẻ giá", icon: "tags" },
  { code: "shield", name: "Cảnh báo", icon: "exclamation-circle" },
];
